import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  retraitProduit: {},
};

export const retraitProduitSlice = createSlice({
  name: "retraitProduit",
  initialState,

  reducers: {
    setRetraitProduitData: (state, action) => {
      const { item, value, type = "RETRAIT", date } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.retraitProduit)) state.retraitProduit = {}; // 🛡️
      state.retraitProduit[item] = { item, value, type, date };
    },

    setRetraitProduitSent: (state, action) => {
      state.retraitProduitSent = action.payload;
    },

    clearRetraitProduit: (state) => {
      state.retraitProduit = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setRetraitProduitData,
  clearRetraitProduit,
  setRetraitProduitSent,
} = retraitProduitSlice.actions;

export default retraitProduitSlice.reducer;
